module.exports = __webpack_public_path__ + "img/man.291718fc.jpg";